export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'boltGallery': { id: 'boltGallery', page: 'gallery', getter: () => import(/* webpackChunkName: 'gallery' */ 'components/bolt/gallery/gallery') },
	'boltSynopsis': { id: 'boltSynopsis', page: 'synopsis', getter: () => import(/* webpackChunkName: 'synopsis' */ 'components/bolt/synopsis/synopsis') },
	'explainer': { id: 'explainer', page: 'imageTiles', getter: () => import(/* webpackChunkName: 'imageTiles' */ 'components/bolt/imageTiles/imageTiles') },
	'aspectRatioTrailer': { id: 'aspectRatioTrailer', page: 'aspectRatioTrailer', getter: () => import(/* webpackChunkName: 'aspectRatioTrailer' */ 'components/bolt/aspectRatioTrailer/aspectRatioTrailer') }
};
export const sections = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
